(() => {
  const root = document.getElementById('kf-showcase');
  if (!root) return;
  const $ = id => root.querySelector(`#${id}`);
  const form = $('kf-search-form');
  const mounting = $('kf-mounting');
  const shape = $('kf-shape');
  const hero = $('kf-hero');
  const experience = $('kf-experience');
  const slides = [...root.querySelectorAll('.kf-hero-slide')];
  let slideIndex = 0;

  function showSlide(index) {
    slideIndex = (index + slides.length) % slides.length;
    slides.forEach((slide,i) => {
      slide.classList.toggle('is-active',i === slideIndex);
      slide.setAttribute('aria-hidden',String(i !== slideIndex));
    });
    const current = slides[slideIndex];
    $('kf-hero-title').textContent = current.dataset.title;
    $('kf-hero-description').textContent = current.dataset.description;
    $('kf-hero-status').textContent = current.dataset.title;
  }
  $('kf-hero-previous').addEventListener('click',() => showSlide(slideIndex-1));
  $('kf-hero-next').addEventListener('click',() => showSlide(slideIndex+1));
  hero.addEventListener('keydown',event => {
    if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    showSlide(slideIndex + (event.key === 'ArrowRight' ? 1 : -1));
  });
  let touchStart = null;
  hero.addEventListener('touchstart',event => {touchStart=event.touches[0];},{passive:true});
  hero.addEventListener('touchend',event => {
    if (!touchStart) return;
    const touch=event.changedTouches[0], dx=touch.clientX-touchStart.clientX, dy=touch.clientY-touchStart.clientY;
    if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) showSlide(slideIndex+(dx<0?1:-1));
    touchStart=null;
  },{passive:true});

  function drawBasin() {
    const svg=root.querySelector('.kf-basin-diagram svg');
    const outlines = {
      oval: { outer:'<ellipse cx="245" cy="145" rx="165" ry="90"/>', inner:'<ellipse cx="245" cy="145" rx="145" ry="70"/>', left:80, right:410, top:55, bottom:235 },
      round: { outer:'<circle cx="245" cy="145" r="100"/>', inner:'<circle cx="245" cy="145" r="82"/>', left:145, right:345, top:45, bottom:245 },
      rectangular: { outer:'<rect x="80" y="55" width="330" height="180" rx="18"/>', inner:'<rect x="98" y="73" width="294" height="144" rx="14"/>', left:80, right:410, top:55, bottom:235 },
      square: { outer:'<rect x="145" y="45" width="200" height="200" rx="14"/>', inner:'<rect x="163" y="63" width="164" height="164" rx="10"/>', left:145, right:345, top:45, bottom:245 },
      // Plan silhouettes referenced to catalogue p.78 (corner), model 40480 (irregular), and model 43451 (semi-round).
      corner: { outer:'<path d="M238 52Q245 45 252 52L403 203Q410 210 410 220Q410 235 395 235H95Q80 235 80 220Q80 210 87 203Z"/>', inner:'<path d="M230 91Q245 76 260 91L374 205Q380 216 367 216H123Q110 216 116 205Z"/>', left:80, right:410, top:48.5, bottom:235, drainY:170 },
      irregular: { outer:'<path d="M80 155C80 95 125 55 190 55C255 55 267 95 310 75C367 48 410 86 410 130C410 190 350 235 265 235C170 235 80 220 80 155Z"/>', inner:'<path d="M100 155C100 106 135 75 190 75C246 75 266 116 318 94C360 75 390 100 390 130C390 180 340 215 265 215C181 215 100 202 100 155Z"/>', left:80, right:410, top:55, bottom:235, drainY:155 },
      semi_round: { outer:'<path d="M143 35H347Q362 35 362 50V128A117 117 0 0 1 128 128V50Q128 35 143 35Z"/>', inner:'<path d="M153 53H337Q344 53 344 60V128A99 99 0 0 1 146 128V60Q146 53 153 53Z"/>', left:128, right:362, top:35, bottom:245, drainY:160 }
    };
    const selected=shape.value;
    const outline=outlines[selected] || { outer:'<rect x="80" y="55" width="330" height="180" rx="12" stroke-dasharray="7 6"/>', inner:'', left:80, right:410, top:55, bottom:235 };
    const name=shape.selectedOptions[0]?.textContent || 'Basin';
    const {left,right,top,bottom,drainX=245,drainY=145}=outline;
    const widthLine=right+28;
    svg.innerHTML=`<defs><marker id="kf-plan-arrow" viewBox="0 0 8 8" markerWidth="6" markerHeight="6" refX="4" refY="4" orient="auto-start-reverse"><path d="M0 0L8 4L0 8Z" fill="#31594e"/></marker></defs>
      <g fill="none" stroke="#31594e" stroke-width="2.4">${outline.outer}${outline.inner}</g>
      <g class="kf-plan-drain" fill="none" stroke="#31594e" stroke-width="1.8"><title>Drain opening</title><circle cx="${drainX}" cy="${drainY}" r="13"/><circle cx="${drainX}" cy="${drainY}" r="8"/></g>
      <g fill="none" stroke="#31594e" stroke-width="1"><path d="M${left} ${bottom+8}V281 M${right} ${bottom+8}V281 M${right+8} ${top}H${widthLine+5} M${right+8} ${bottom}H${widthLine+5}"/></g>
      <g fill="none" stroke="#31594e" stroke-width="1.5" marker-start="url(#kf-plan-arrow)" marker-end="url(#kf-plan-arrow)"><path d="M${left} 273H${right}"/><path d="M${widthLine} ${top}V${bottom}"/></g>
      <g fill="#31594e" font-family="Arial,sans-serif" font-size="14"><text x="245" y="299" text-anchor="middle">Width</text><text x="${widthLine+13}" y="${(top+bottom)/2}" dominant-baseline="middle">Depth</text></g>`;
    svg.setAttribute('aria-label',`${name} basin, orthographic top view with a drain opening. Width left to right; depth front to back.`);
    root.querySelector('.kf-basin-diagram').dataset.shape=shape.value;
  }

  function updateSteps() {
    shape.disabled=!mounting.value;
    const ready=Boolean(mounting.value && shape.value);
    $('kf-search-options').hidden=!ready;
    $('kf-search-final').hidden=!ready;
    $('kf-step-hint').hidden=ready;
    $('kf-step-hint').textContent=mounting.value?'Choose a shape to add dimensions and details.':'Choose a basin type to see the next options.';
    if (ready) drawBasin();
  }
  mounting.addEventListener('change',updateSteps);
  shape.addEventListener('change',updateSteps);
  form.addEventListener('reset',()=>queueMicrotask(updateSteps));
  // Browser-restored selections do not emit change; resync after restoration finishes.
  window.addEventListener('pageshow',()=>requestAnimationFrame(updateSteps));
  updateSteps();

  let frame=0;
  function updateScroll() {
    frame=0;
    const top=experience.getBoundingClientRect().top;
    const progress=Math.min(1,Math.max(0,-top/180));
    root.style.setProperty('--kf-reveal',String(progress));
    const visible=progress>.25;
    if (!visible && form.contains(document.activeElement)) document.activeElement.blur();
    root.classList.toggle('kf-search-revealed',visible);
    form.inert=!visible;
    $('kf-hero-content').inert=progress>.9;
  }
  function schedule() {if(!frame)frame=requestAnimationFrame(updateScroll);}
  $('kf-hero-search').addEventListener('click',()=>{
    root.classList.add('kf-search-revealed');form.inert=false;
    form.scrollIntoView({behavior:'instant',block:'start'});
    updateScroll();
    mounting.focus({preventScroll:true});
  });
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  root.classList.add('kf-experience-ready');
  updateScroll();
})();
